// extracted by mini-css-extract-plugin
export var bg = "index-module--bg--w+mwI";
export var hidden = "index-module--hidden--mOexB";
export var hiddenBottom = "index-module--hiddenBottom--Rem-D";
export var hiddenTop = "index-module--hiddenTop--Qo+xF";
export var logo = "index-module--logo--bNd9E";
export var name = "index-module--name--Ad0He";
export var project = "index-module--project--mAUkg";